export const SHIP_EDITOR_MIN_TIER = 82;
export const LINE_SEPARATOR = "\r\n";
